import { DataLayer } from "@sazka/utils/data-layer";

export const useAnalyticsCollectActions = () => {
    $("[data-a-action]").on("click", (e) => {
        const el = $(e.currentTarget);
        const event = el.data("a-action");
        const data = {};
        switch (event) {
            case "show.products":
        }

        for (let i = 0; i < el[0].attributes.length; i++) {
            const attr = el[0].attributes[i];
            if (attr.name != "data-a-action" && attr.name.indexOf("data-a-") == 0) {
                const str = attr.name.replace("data-a-", "");
                const items = str.split("-");
                let objPointer = data;
                for (let x = 0; x < items.length; x++) {
                    const element = items[x];
                    if (!objPointer[element]) {
                        objPointer[element] = x === items.length - 1 ? attr.value : {};
                    }
                    objPointer = objPointer[element];
                }
                objPointer = data;
            }
        }

        DataLayer.push({
            event: `action.${event}`,
            action: data,
        });
    });
};
